import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Box,
  Chip,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import style from 'components/moreDetails/MoreDetailsStyle';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import CommonDialog from 'components/commonDialog/CommonDialog';
import { getDateFormat } from 'utils/utils';
import CommonImageModal from 'components/commonImageModal/CommonImageModal';
import CommonCardDetails from 'components/commonCardDetails/CommonCardDetails';
import pdfImg from 'assets/images/pdfImg.svg';

function MoreDetailsDriver(props) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [checkboxEdit, setcheckboxEdit] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const regionSelection = useSelector(
    (state) => state?.userServiceRegion?.userServiceRegion?.data
  );
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );

  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedImage(null);
    setOpen(false);
    setEdit(false);
    setcheckboxEdit(false);
  };

  const handleOnError = (e) => {
    e.target.src = pdfImg;
  };

  const onEditButton = () => {
    setEdit(true);
  };

  const onCheckBoxButton = () => {
    setcheckboxEdit(true);
  };

  const serviceArea = [
    {
      placeholder: 'Add ServiceArea',
      required: true,
      type: 'text',
      name: 'serviceRegions',
      label: 'Add your Serviceable Area',
      star: '*',
      autoComplete: true,
    },
  ];

  const handleRedirect = (data) => {
    setEdit(false);
  };

  const handleCheckboxChange = (serviceId) => {
    if (selectedCheckboxes.includes(serviceId)) {
      setSelectedCheckboxes(
        selectedCheckboxes.filter((id) => id !== serviceId)
      );
    } else {
      setSelectedCheckboxes([...selectedCheckboxes, serviceId]);
    }
  };

  const handleSubmit = () => {
    setcheckboxEdit(false);
  };

  const filteredFiles = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === 'File'
  );
  const filteredImages = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === 'Image'
  );
  const filteredTextDocuments = props?.subVendorMoreDetails?.filter(
    (val) => val.attributeType === 'text'
  );

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent="space-around"
        alignItems="start"
        spacing={2}
      >
        <Grid
          item
          container
          className="justifyBetween flexRow"
          spacing={1}
          md={8.3}
          sm={12}
        >
          {props?.subVendorMoreDetails?.length === 0 ? (
            <Grid className="width100 tableMain">
              <CommonNoDataFound />
            </Grid>
          ) : (
            <>
              {filteredFiles?.length > 0 && (
                <Typography className="mb20 padding10 font18">
                  Text With File Document
                </Typography>
              )}
              <Grid container className="justifyBetween flexRow mb30" md={12}>
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === 'File') {
                    return (
                      <CommonCardDetails md={5.6} sm={12} val={document} handleOpen={handleOpen}/>
                    );
                  }
                  return null;
                })}
              </Grid>

              {filteredTextDocuments?.length > 0 && (
                <div className="dashedborder width100"> </div>
              )}
              {filteredTextDocuments?.length > 0 && (
                <Typography className="mb20 padding10 font18">
                  Text Documents
                </Typography>
              )}
              <Grid container className="justifyBetween flexRow mb30" md={12}>
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === 'text') {
                    return (
                      <Grid
                        item
                        md={5.5}
                        sm={12}
                        justifyContent="space-between"
                        className="dlImgMain borderStyle mb20"
                        key={document.id}
                      >
                        <Grid
                          item
                          container
                          className="justifyBetween flexRow padding10 backgroundGrey"
                        >
                          <Grid item>
                            <h1 className="colorBlack font14 fontMedium textOverflow">
                              {document?.complianceName}
                              {document?.isMandatory && (
                                <span className="colorRed">*</span>
                              )}
                            </h1>
                            {document?.atributeValue && (
                              <p className="font12 fontNormal colorGrey">
                                Number: {document?.atributeValue}
                              </p>
                            )}
                            {document?.expiryDate && (
                              <p className="font12 fontNormal colorBlue">
                                <span className="colorBlue">Exp</span>
                                {getDateFormat(
                                  document?.expiryDate,
                                  'moreDetails'
                                )}
                              </p>
                            )}
                          </Grid>
                          <Grid item>
                            {document?.status && (
                              <Tooltip title={document?.rejectionReason}>
                                <Typography
                                  className={` ${
                                    document?.status + 'Btn'
                                  } flexDirection`}
                                >
                                  {document.status === 'Rejected' && (
                                    <ErrorOutlineIcon className="marginRight3 font16" />
                                  )}
                                  {document?.status}
                                </Typography>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    );
                  }
                  return null;
                })}
              </Grid>
              {filteredImages?.length > 0 && (
                <div className="dashedborder width100"></div>
              )}
              {filteredImages?.length > 0 && (
                <Typography className="mb20 padding10 font18">
                  Text with MultiImage
                </Typography>
              )}
              <Grid container className="justifyBetween flexRow mb30" md={12}>
                {props.subVendorMoreDetails?.map((document, idx) => {
                  if (document?.attributeType === 'Image') {
                    return (
                      <CommonCardDetails md={5.9} sm={12} val={document} handleOpen={handleOpen}/>
                     
                    );
                  }
                  return null;
                })}
              </Grid>
            </>
          )}
        </Grid>

        {/* ---Service Area--- */}
        <Grid item container md={3.3} sm={12}>
          <Grid item container className="alignStart" rowSpacing={3}>
              <Grid container className="marginTop25">
                  <h1 className="font16 fw600 colorPrimary"> Services</h1>
                {props?.chooseYourServiceData?.length === 0 ? (
              <CommonNoDataFound />
            ) : (
              <Grid container item direction="row">
              {props?.chooseYourServiceData?.some(ele => ele?.status === 'Active') ? (
                props?.chooseYourServiceData?.map((ele, id) => (
                  ele?.status === 'Active' && (
                    <Chip
                      label={ele.name}
                      variant="outlined"
                      className="mr10 mb10 colorGrey font16 forntNormal"
                    />
                  )
                ))
              ) : (
                <Grid container item xs={12} className='justifyCenter'>
                <CommonNoDataFound />
                </Grid>
              )}
                </Grid>
                )}
              </Grid>
          </Grid>
        </Grid>
      </Grid>
     
      {open && <CommonImageModal
        open={open}
        handleClose={handleClose}
        selectedImage={selectedImage}
    />}

      {edit ? (
        <CommonDialog
          open={edit}
          handleClose={handleClose}
          formData={serviceArea}
          button={'Add'}
          onSubmittBtn={handleRedirect}
          optionData={regionSelection}
          type={'Edit Service'}
          selectType={'edit'}
          defaultValues={props?.subVendorLocation}
        />
      ) : null}
    </div>
  );
}

export default MoreDetailsDriver;
